import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';

export function fetchMultiStepReactionPreview({ databaseId, rootReactionId, stepReactionIds }) {
  return MessageBroker.send(RequestUrls.rsMultiStepPreview, { databaseId, rootReactionId, stepReactionIds });
}

// --- Concurrent (fixed-slot) scheduler ---
const MAX_CONCURRENT_MULTI_STEP = 3;
const _concurrentQueue = [];
let _concurrentActive = 0;

function _tryDispatchConcurrent() {
  if (_concurrentActive < MAX_CONCURRENT_MULTI_STEP && _concurrentQueue.length) {
    const { args, resolve, reject } = _concurrentQueue.shift();
    _concurrentActive += 1;
    fetchMultiStepReactionPreview(args)
      .then(resolve)
      .catch(reject)
      .finally(() => {
        _concurrentActive -= 1;
        _tryDispatchConcurrent();
      });
  }
}

export function rateLimitedFetchMultiStepReactionPreview(args) {
  return new Promise((resolve, reject) => {
    _concurrentQueue.push({ args, resolve, reject });
    _tryDispatchConcurrent();
  });
}

export function clearRateLimitedMultiStepReactionPreviewQueue() {
  _concurrentQueue.length = 0;
}
